import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import '../../index.css';
import closeIcon from '../../icons/ic-paymentAgreement-close.png';
import infoIcon from '../../icons/ic-paymentAgreement-info.png';
import checkIcon from '../../icons/ic-paymentAgreement-checked.png';
import uncheckIcon from '../../icons/ic-paymentAgreement-unchecked.png';
import ShopModeContext from '../../contexts/ShopModeContext';
import {
  addMobiliansPayment,
  addKGInisisPayment,
  getUserDetail,
} from '../../modules/NetworkFunction';
import AuthContext from '../../contexts/AuthContext';
import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router-dom';
import sha256 from 'crypto-js/sha256';
import { ReactInicis } from '@hellojh/react-inicis';

const Modal = styled.div`
  position: relative;
  width: 526px;
  height: 310px;
  background-color: #ffffff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  text-align: flex-start;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

function PaymentAgreementModal(props) {
  const {
    open,
    close,
    paymentURL,
    isPromotion,
    setIsPromotion,
    didAgreement,
    setDidAgreement,
  } = props;

  const location = useLocation();
  const { auth: token } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);

  const [userInfo, setUserInfo] = useState(null); // user 정보 데이터
  const [isLoaded, setIsLoaded] = useState(false);

  const [makeShopPaymentURL, setMakeShopPaymentURL] = useState(
    process.env.REACT_APP_PAYMENT_URL
  );
  //const [testUrl, setTestUrl] = useState(process.env.REACT_APP_PAYMENT_URL);
  //const [serverUrl, setServerUrl] = useState("https://shop.wizmon.co.kr");

  // 이니시스 정기결제 - 인증요청 시 필요한 정보
  const [version, setVersion] = useState('1.0');
  const [mid, setMid] = useState('CAEwizm39a');
  // const [mid, setMid] = useState("INIBillTst");
  const [oid, setOid] = useState(uuidv4());
  const [price, setPrice] = useState(
    process.env.REACT_APP_PAYMENT_URL == 'https://test.wizmon.com:3001' ||
      process.env.REACT_APP_PAYMENT_URL == 'test.wizmon.com:3001'
      ? 1000
      : 77000
  ); // 로컬 1000원, 실제 77000원
  const [timestamp, setTimestamp] = useState(new Date().getTime());
  const [use_chkfake, setUse_chkfake] = useState('Y');
  const [mKey, setmKey] = useState('bDI2cHJ4UFcrR2g5b0VhTHNQTXEvdz09');
  // const [mKey, setmKey] = useState(process.env.REACT_APP_INICIS_MKEY);
  const [signKey, setSignKey] = useState(sha256(mKey));
  const [signature, setSignature] = useState(
    sha256('oid=' + oid + '&price=' + price + '&timestamp=' + timestamp)
  );
  const [verification, setVerification] = useState(
    sha256(
      'oid=' +
        oid +
        '&price=' +
        price +
        '&signKey=' +
        signKey +
        '&timestamp=' +
        timestamp
    )
  );
  const [offerPeriod, setOfferPeriod] = useState('M2'); // 월 자동결제
  const [currency, setCurrency] = useState('WON');
  const [productName, setProductName] = useState('유료 요금제');
  const [acceptMethod, setAcceptMethod] = useState(
    'below1000:va_receipt:centerCd(Y)'
  );
  // const [acceptMethod, setAcceptMethod] = useState("below1000:va_receipt:centerCd(Y):BILLAUTH(Card)");

  const [isTest, setIsTest] = useState(false); // 로컬: true, 실제: false,

  const [isPurchase, setIsPurchase] = useState(0);
  const [payData, setPayData] = useState();
  const [isCallback, setIsCallback] = useState(false);

  useEffect(() => {
    if (!isLoaded) {
      getUserDetail(
        null,
        (v) => {
          setUserInfo(v.user);
        },
        setIsLoaded,
        (e) => {
          console.log('getuserdetail', e);
        },
        token
      );
    }
  }, [userInfo, isLoaded]);

  const agreementPaymentClick = () => {
    if (shopMode === 'cafe24') {
      document.location.href = paymentURL;
    } else {
      setIsPurchase(isPurchase + 1);

      console.log('makeshop payment url: ', makeShopPaymentURL);

      // 현재 페이지 도메인 이름 출력

      setPayData({
        version: version,
        mid: mid,
        oid: oid,
        productPrice: price,
        timestamp: timestamp,
        use_chkfake: use_chkfake,
        mKey: mKey,
        offerPeriod: offerPeriod,
        currency: currency,
        productName: productName,
        buyerName: userInfo?.userName,
        buyerTel: userInfo?.userPhone,
        buyerEmail: userInfo?.userEmail,
        returnUrl:
          makeShopPaymentURL == 'https://dev.wizmon.co.kr'
            ? 'https://dev.wizmon.co.kr/apis/payment/callback'
            : 'https://shop.wizmon.co.kr/apis/payment/callback',
        closeUrl:
          makeShopPaymentURL == 'https://dev.wizmon.co.kr'
            ? 'https://dev.wizmon.co.kr/mypage/payment-close'
            : 'https://shop.wizmon.co.kr/mypage/payment-close',
        acceptmethod: acceptMethod,
      });
    }
    console.log('payData : ', payData);
  };

  const toggleImage = () => {
    console.log('toggleImage');
    setDidAgreement((prev) => !prev);

    if (shopMode === 'cafe24') {
      document.location.href = paymentURL;
    } else {
      console.log('makeShopPaymentURL: ', makeShopPaymentURL);

      // 현재 페이지 도메인 이름 출력

      setPayData({
        version: version,
        mid: mid,
        oid: oid,
        productPrice: price,
        timestamp: timestamp,
        use_chkfake: use_chkfake,
        mKey: mKey,
        offerPeriod: offerPeriod,
        currency: currency,
        productName: productName,
        buyerName: userInfo?.userName,
        buyerTel: userInfo?.userPhone,
        buyerEmail: userInfo?.userEmail,
        returnUrl:
          makeShopPaymentURL == 'https://dev.wizmon.co.kr'
            ? 'https://dev.wizmon.co.kr/apis/payment/callback'
            : 'https://shop.wizmon.co.kr/apis/payment/callback',
        closeUrl:
          makeShopPaymentURL == 'https://dev.wizmon.co.kr'
            ? 'https://dev.wizmon.co.kr/mypage/payment-close'
            : 'https://shop.wizmon.co.kr/mypage/payment-close',
        acceptmethod: acceptMethod,
      });
    }
    console.log('payData : ', payData);
  };

  return (
    <div className={open ? 'openModal modal' : 'modal'}>
      {isPurchase > 0 ? (
        <ReactInicis payData={payData} isPurchase={isPurchase} />
      ) : null}
      <Modal style={{ height: isPromotion ? 321 : 310 }}>
        <Header>
          <div>'약관동의'</div>
          <CloseButton onClick={close}></CloseButton>
        </Header>

        <ContentContainer>
          <Content>
            <AgreementButton onClick={toggleImage}>
              <img
                src={didAgreement ? checkIcon : uncheckIcon}
                alt="paymentAgreementCheck"
                style={{
                  width: '32px',
                  height: '32px',
                }}
              />
            </AgreementButton>
            <span>유료서비스 약관 전체동의 (필수)</span>
          </Content>

          <AgreementDocument
            href="https://dazzling-whale-1af.notion.site/588dcdd26baa42b683f344098eab657a"
            target="_blank"
            rel="noreferrer"
          >
            보기
          </AgreementDocument>
        </ContentContainer>

        <DescriptionContainer>
          <img
            src={infoIcon}
            style={{
              display: 'inline-block',
              width: '28px',
              height: '28px',
            }}
            alt="paymentAgreementInfo"
          />
          <div>
            <span>
              정기결제를 원하지 않을 경우,
              <br />
              결제창에서 <b>‘신용카드 자동연장 서비스 신청하기’</b>를 해제해
              주세요.
            </span>
          </div>
        </DescriptionContainer>
        <PayButtonContainer>
          <PayButton
            didAgreement={didAgreement}
            disabled={!didAgreement}
            onClick={agreementPaymentClick}
          >
            결제하러 가기
          </PayButton>
        </PayButtonContainer>
      </Modal>
    </div>
  );
}

export default PaymentAgreementModal;

const Header = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 24px;
  font-weight: 400;
  justify-content: space-between;
  padding: 20px 30px 0 30px;
`;

const ContentContainer = styled.div`
  width: 466px;
  height: 72px;
  background-color: rgba(196, 196, 196, 0.2);
  font-size: 20px;
  font-weight: 400;
  margin-top: 32px;
  margin-left: 30px;
  margin-right: 30px;
  border-radius: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 15px;
  color: #000;
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

const AgreementButton = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  background: none;
  cursor: pointer;
`;

const AgreementDocument = styled.a`
  color: #ffb600;
  font-size: 14px;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
`;

const DescriptionContainer = styled.div`
  width: 466px;
  height: 44px;
  background-color: rgba(255, 182, 0, 0.2);
  font-size: 12px;
  font-weight: 400;
  margin-top: 8px;
  margin-left: 30px;
  margin-right: 30px;
  border-radius: 7px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 15px;
  color: #6e6e6e;
  gap: 14px;
`;

const PayButtonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 30px 30px 30px 0;
`;

const PayButton = styled.button`
  display: flex;
  height: 40px;
  font-weight: 700;
  padding: 10px 30px;
  border-radius: 20px;
  color: #fff;
  background-color: ${(props) => (props.didAgreement ? '#FFB600' : '#CCCCCC')};
  font-size: 20px;
  cursor: pointer;
  border-width: 0;
  justify-content: center;
  align-items: center;
`;

const PromotionContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 16px;
  padding: 32px 30px 4px 30px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const PromotionTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: start;
  font-size: 18px;
  font-weight: 400;
`;

const PromotionInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;

const Input = styled.input`
  height: 38px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding-left: 12px;
  font-size: 18px;
  width: ${({ width }) => width}px;
`;

const SubmitButton = styled.div`
  width: 83px;
  height: 38px;
  padding: 7px 12px 8px 12px;
  margin-left: 12px;
  text-align: center;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  border-width: 0;
  background-color: #b5b5b5;
  color: #fff;
  cursor: pointer;
`;

const CloseButton = styled.button`
  background-image: url(${closeIcon});
  background-size: cover;
  border: none;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  width: 32px;
  height: 32px;
  cursor: pointer;
`;
